import { CssType, ThemeType } from 'src/theme/jss-types';
import { refreshButton } from 'src/theme/cssSnippets/commonSnippets';
import { MIN_WIDTH, MOBILE_BREAK_POINT } from 'src/globals';

export const DownloadRequestsStyles = (theme: ThemeType): CssType => ({
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: MIN_WIDTH,
  },
  tableContainer: {
    flexGrow: 1,
    padding: '10px 20px 20px 20px',
    backgroundColor: '#f9f9f9',
    overflowX: 'auto',
  },
  select: {
    width: 200,
    '& .ant-select-selector': {
      border: '1px solid #D9D9D9 !important',
      borderRadius: '4px !important',
    },
  },
  datePicker: {
    width: 280,
    marginLeft: 10,
    border: '1px solid #D9D9D9 !important',
    borderRadius: '4px !important',
    '& .ant-calendar-picker-input': {
      borderRadius: '4px',
      padding: 0,
    },
    '& .ant-calendar-range-picker-separator': {
      verticalAlign: 'baseline',
    },
  },
  table: {
    '& .ant-table-pagination.ant-pagination': {
      margin: '16px 0',
    },
    '& .ant-pagination-item': {
      display: 'none !important',
    },
    '& .ant-pagination-jump-prev, & .ant-pagination-jump-next': {
      display: 'none !important',
    },
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '10px 0',
    gap: '8px',
  },
  selectWithoutBorder: {
    margin: '0 5px',
  },
  refreshButton: {
    ...refreshButton({ color: theme.primaryColor }),
    marginTop: 0,
    marginLeft: 4,
  },
  statusBadge: {
    padding: '4px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 500,
    display: 'inline-block',
  },
  statusPending: {
    backgroundColor: '#fff7e6',
    color: '#fa8c16',
    border: '1px solid #ffd591',
  },
  statusFailed: {
    backgroundColor: '#fff1f0',
    color: '#cf1322',
    border: '1px solid #ffa39e',
  },
  statusSuccess: {
    backgroundColor: '#f6ffed',
    color: '#52c41a',
    border: '1px solid #b7eb8f',
  },
  filterText: {
    fontSize: '12px',
    color: '#666',
    lineHeight: '1.8',
    '& div': {
      marginBottom: '4px',
    },
  },
  filterLabel: {
    fontWeight: 'bold',
    color: '#333',
  },
  downloadButton: {
    color: theme.primaryColor,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  [`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
    tableContainer: {
      padding: '10px',
    },
  },
});
